/**
 * Discriminates whether a history row is a case or an investigation.
 * Drives which detail route the row links to.
 */
export type EmployeeHistoryItemType = 'case' | 'investigation';

/**
 * Employee history item domain entity.
 * Represents a single case or investigation associated with an employee
 * in the Employee 360 View history table.
 */
export class EmployeeHistoryItemEntity {
  /** Routing identifier used to build the detail URL. */
  public id!: string;
  /** Whether this item is a case or an investigation. */
  public itemType!: EmployeeHistoryItemType;
  /** Human-readable identifier shown in the Case ID column (e.g. SS-26010001). */
  public displayId!: string;
  public title!: string;
  public priority!: string;
  public status!: string;
  /** ISO date string for when the item was created. */
  public createdDate!: string;
}
